import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story02.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story02'
const figure = articleFigure(dir)

export const story02: Article = {
  id: 2,
  slug: 'the-battle-for-oak-flat',
  order: 2,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('copper'),
  author: 'Noel Lyn Smith',
  region: [
    {
      name: t.regionName,
      country: t.regionCountry,
      coordinates: [-111.0517, 33.3678],
      impact: 'human',
    },
  ],
  impactList: ['human', 'environmental', 'geopolitical'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      figure('02.jpg', t.captions[1]),
      { type: 'prose', blocks: [...t.prose[1]] },
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[2]] }, // Why Oak Flat is sacred
      figure('03.jpg', t.captions[2]),
      { type: 'prose', blocks: [...t.prose[3]] },
      { type: 'quote', ...t.quotes[1] },
      { type: 'prose', blocks: [...t.prose[4]] },
      { type: 'prose', blocks: [...t.prose[5]] }, // The metal powering the modern world
      figure('04.jpg', t.captions[3]),
      { type: 'prose', blocks: [...t.prose[6]] }, // From sacred land to mining project
      { type: 'quote', ...t.quotes[2] },
      { type: 'prose', blocks: [...t.prose[7]] },
      figure('05.jpg', t.captions[4]),
      { type: 'prose', blocks: [...t.prose[8]] }, // But the battle isn’t over
      figure('06.jpg', t.captions[5]),
      { type: 'prose', blocks: [...t.prose[9]] },
    ],
  },
}
